import React from 'react';
import { MapPin, Clock, BadgeDollarSign, Map } from 'lucide-react';
export function DifferentialsSection() {
  const differentials = [{
    icon: <MapPin className="w-8 h-8 text-primary" data-id="element-32" />,
    title: 'Vamos a tu lugar',
    description: 'Nuestro equipo se desplaza hasta donde está la máquina.'
  }, {
    icon: <Clock className="w-8 h-8 text-primary" data-id="element-33" />,
    title: 'Respuesta inmediata',
    description: 'Ante cualquier falla, actuamos rápido. Sin vueltas ni demoras.'
  }, {
    icon: <BadgeDollarSign className="w-8 h-8 text-primary" data-id="element-34" />,
    title: 'Precio justo',
    description: 'Presupuesto claro antes de arrancar. Sin sorpresas ni costos ocultos.'
  }, {
    icon: <Map className="w-8 h-8 text-primary" data-id="element-35" />,
    title: 'Toda la Argentina',
    description: 'Norte, sur, este u oeste. Llegamos a donde estés.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-36">
      <div className="container mx-auto px-4" data-id="element-37">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-38">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary text-white font-semibold text-sm mb-4" data-id="element-39">
            ¿Por qué elegirnos?
          </span>
          <h2 className="text-gray-900 font-heading font-bold" data-id="element-40">
            No somos cualquier servicio técnico
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-41">
          {differentials.map((diff, index) => <div key={index} className="bg-lightBg rounded-2xl p-8 text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-42">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6" data-id="element-43">
                {diff.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 font-heading" data-id="element-44">
                {diff.title}
              </h3>
              <p className="text-gray-600" data-id="element-45">{diff.description}</p>
            </div>)}
        </div>

        <div className="max-w-4xl mx-auto bg-whatsapp/10 border border-whatsapp/20 rounded-xl p-4 text-center" data-id="element-46">
          <p className="text-whatsappDark font-semibold flex items-center justify-center gap-2" data-id="element-47">
            <MapPin className="w-5 h-5" data-id="element-48" />
            Cobertura nacional: CABA · GBA · Interior · Todo el país
          </p>
        </div>
      </div>
    </section>;
}